var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrnkQty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 29.607c0 16.352-13.88 29.607-31 29.607-17.12 0-31-13.255-31-29.607C2 13.255 15.88 0 33 0c17.12 0 31 13.255 31 29.607",
    fill: "#FDE7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 65c-8.75 0-16.943-3.298-23.074-9.287a1.341 1.341 0 0 1-.033-1.88 1.3 1.3 0 0 1 1.854-.034c5.638 5.51 13.186 8.544 21.253 8.544 8.045 0 15.578-3.02 21.213-8.504a1.3 1.3 0 0 1 1.854.038c.502.53.486 1.372-.038 1.88C49.904 61.718 41.725 65 33 65",
    fill: "#FFB061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.896 17.604H17.237c-2.117 0-3.833 1.74-3.833 3.884l1.272 32.389c4.543 3.036 9.975 4.938 15.85 5.277a34.456 34.456 0 0 0 1.577.052c.129.003.26.006.386.006 7.223-.014 13.86-2.394 19.124-6.363l.115-31.36c0-2.146-1.715-3.885-3.832-3.885",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.247 18.206h-27.36c-1.89 0-3.421 1.739-3.421 3.884l1.156 32.989c4.627 2.624 10.027 4.135 15.8 4.135 6.338 0 12.229-1.82 17.14-4.939l.106-32.185c0-2.145-1.532-3.884-3.42-3.884",
    fill: "#FFB850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.425 13.46c-.883-3.657-4.28-6.384-8.347-6.384-3.09 0-5.79 1.578-7.3 3.938a8.72 8.72 0 0 0-5.91-2.284c-3.567 0-6.624 2.098-7.918 5.082-4.665.078-8.424 3.74-8.424 8.253 0 4.562 3.84 8.261 8.577 8.261.875 0 1.718-.128 2.513-.362a6.27 6.27 0 0 0 5.253 2.795c2.64 0 4.883-1.587 5.792-3.819a6.364 6.364 0 0 0 2.785.659 6.284 6.284 0 0 0 4.699-2.1 8.724 8.724 0 0 0 5.7 2.1c4.736 0 8.577-3.698 8.577-8.26 0-3.696-2.52-6.824-5.997-7.879M46.945 33.6c0 1.274-1.018 2.306-2.275 2.306-1.256 0-2.275-1.032-2.275-2.306s1.019-2.306 2.275-2.306c1.257 0 2.275 1.032 2.275 2.306M43.213 40.04c0 .9-.72 1.63-1.608 1.63a1.62 1.62 0 0 1-1.609-1.63c0-.901.72-1.631 1.609-1.631.888 0 1.608.73 1.608 1.63M24.554 46.684c0 .9-.72 1.63-1.609 1.63a1.62 1.62 0 0 1-1.608-1.63c0-.9.72-1.63 1.608-1.63.889 0 1.609.73 1.609 1.63M28.813 53.427c0 .9-.72 1.63-1.608 1.63a1.62 1.62 0 0 1-1.609-1.63c0-.9.72-1.63 1.609-1.63.888 0 1.608.73 1.608 1.63",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.845 49.647V46.02c3.354 0 6.082-3.256 6.082-7.26 0-4.005-2.728-7.262-6.082-7.262v-3.625c5.326 0 9.659 4.883 9.659 10.887 0 6.002-4.333 10.886-9.66 10.886",
    fill: "#E5E5E5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrnkQty);
export default __webpack_public_path__ + "static/media/drnkQty.155244d6b49d4846683c4b23929ad7d5.svg";
export { ForwardRef as ReactComponent };